// Complete trading glossary — 35 curated terms, translated by RE₿EL LLM pipeline (Sprint B).
// Category and id keys preserved from ES for cross-locale color/lookup consistency.

export const GLOSARIO = [
  {
    id: "order-block",
    termino: "Order Block (OB)",
    categoria: "Smart Money",
    definicion: "机构（smart money）下达重要订单的价格区域。识别为强势上涨前的最后一根看跌蜡烛（看涨OB）或强势下跌前的最后一根看涨蜡烛（看跌OB）。价格往往会回测这些水平。",
    ejemplo: "如果BTC从40K突然上涨到45K，该上涨前的最后一根红色蜡烛就是看涨Order Block。当价格回到该区域时，机构会增加仓位。",
    relacionados: [
      "fair-value-gap",
      "imbalance",
      "liquidity"
    ]
  },
  {
    id: "fair-value-gap",
    termino: "Fair Value Gap (FVG)",
    categoria: "Smart Money",
    definicion: "市场快速移动时产生的价格失衡或低效率，表现为一根蜡烛的上影线与下一根蜡烛的下影线之间存在缺口（在上涨冲动中）。根据价格平衡原理，市场往往会回填这些缺口。",
    ejemplo: "如果蜡烛1的上影线在42,000，蜡烛3的下影线在42,500，那么42,000到42,500之间存在FVG。价格很可能会回来填补它。",
    relacionados: [
      "order-block",
      "imbalance",
      "bos"
    ]
  },
  {
    id: "imbalance",
    termino: "Imbalance / 失衡",
    categoria: "Smart Money",
    definicion: "图表上价格移动过快导致买卖双方未达到平衡的区域。类似于FVG但适用于不同时间框架。失衡区域对价格具有磁铁般的吸引力。",
    relacionados: [
      "fair-value-gap",
      "order-block"
    ]
  },
  {
    id: "bos",
    termino: "Break of Structure (BOS)",
    categoria: "Smart Money",
    definicion: "市场结构突破。当价格在上升趋势中突破前高（或在下降趋势中跌破前低）时发生，确认趋势的延续。与CHoCH不同，因为它确认当前方向。",
    ejemplo: "上升趋势：BTC创造更高的高点和更高的低点。当价格突破最后一个高点时，这就是确认趋势持续的BOS。",
    relacionados: [
      "choch",
      "tendencia"
    ]
  },
  {
    id: "choch",
    termino: "Change of Character (CHoCH)",
    categoria: "Smart Money",
    definicion: "市场性质改变。当前趋势可能正在改变的第一个信号。在上升趋势中，当价格向下突破最后一个相关低点时，CHoCH就会发生。这是BOS确认反转之前的第一个警告。",
    relacionados: [
      "bos",
      "tendencia"
    ]
  },
  {
    id: "liquidity",
    termino: "流动性 (Liquidity)",
    categoria: "Smart Money",
    definicion: "在Smart Money的背景下，流动性是指在低点下方或高点上方累积的止损单。机构需要流动性来填充他们的大额订单，因此价格经常会猎取这些水平（止损猎杀），然后才朝真正的方向移动。",
    ejemplo: "如果许多交易者在40,000（支撑位下方）设置止损，机构可以短暂地将价格推低至40K以下以触发这些止损，收集流动性，然后再上涨。",
    relacionados: [
      "order-block",
      "inducement"
    ]
  },
  {
    id: "inducement",
    termino: "Inducement (IDM)",
    categoria: "Smart Money",
    definicion: "流动性陷阱。旨在吸引散户交易者进入错误仓位的运动，发生在真正的走势之前。价格形成一个虚假的高点或低点，看起来像是一个好的入场点，但实际上是在收集流动性。",
    relacionados: [
      "liquidity"
    ]
  },
  {
    id: "premium-discount",
    termino: "溢价区和折价区",
    categoria: "Smart Money",
    definicion: "价格相对于当前区间的位置。溢价区（区间50%以上）买入成本高——机构在此卖出。折价区（区间50%以下）买入成本低——机构在此买入。使用斐波那契50%作为参考。",
    relacionados: [
      "fibonacci",
      "order-block"
    ]
  },
  {
    id: "soporte",
    termino: "支撑位",
    categoria: "Análisis Técnico",
    definicion: "历史上买方力量超过卖方力量的价格水平，能够阻止或反转价格下跌。价格在该水平反弹的次数越多，支撑位就越强。当支撑位被突破时，它会转变为阻力位。",
    ejemplo: "BTC在过去一个月内已在40,000美元处反弹4次。该水平是一个强支撑位。",
    relacionados: [
      "resistencia",
      "tendencia"
    ]
  },
  {
    id: "resistencia",
    termino: "阻力位",
    categoria: "Análisis Técnico",
    definicion: "历史上卖方力量超过买方力量的价格水平，能够阻止或反转价格上涨。当伴随成交量突破时，阻力位会转变为支撑位。",
    relacionados: [
      "soporte",
      "tendencia"
    ]
  },
  {
    id: "tendencia",
    termino: "趋势 (Trend)",
    categoria: "Análisis Técnico",
    definicion: "价格随时间推移的主要运动方向。上升趋势：高点和低点不断抬高。下降趋势：高点和低点不断降低。横盘趋势：价格在区间内震荡，没有明确方向。",
    relacionados: [
      "bos"
    ]
  },
  {
    id: "vela-japonesa",
    termino: "日本蜡烛图 (Candlestick)",
    categoria: "Análisis Técnico",
    definicion: "在特定时间段内价格的图形表示。实体显示开盘价和收盘价之间的差异。影线（上下影线）显示该时段的最高价和最低价。绿色/白色 = 收盘价高于开盘价（看涨）。红色/黑色 = 收盘价低于开盘价（看跌）。",
    relacionados: [
      "doji",
      "martillo"
    ]
  },
  {
    id: "doji",
    termino: "Doji",
    categoria: "Análisis Técnico",
    definicion: "实体非常小（开盘价≈收盘价）且两侧均有影线的K线。市场犹豫不决的信号。在支撑位/阻力位或延续走势后尤其重要。可能预示反转。",
    relacionados: [
      "vela-japonesa",
      "martillo"
    ]
  },
  {
    id: "martillo",
    termino: "锤子线 (Hammer)",
    categoria: "Análisis Técnico",
    definicion: "实体较小位于上方、下影线较长（至少为实体的2倍）的K线。在下跌趋势后出现时为看涨反转信号。表明买方强烈拒绝更低价格。",
    relacionados: [
      "doji",
      "vela-japonesa"
    ]
  },
  {
    id: "volumen",
    termino: "交易量",
    categoria: "Análisis Técnico",
    definicion: "一段时间内交易的资产数量。交易量验证价格走势。高交易量的上涨冲动比低交易量更可靠。价格与交易量之间的背离可能预示动能衰竭。",
    relacionados: [
      "rsi"
    ]
  },
  {
    id: "fibonacci",
    termino: "Fibonacci回撤",
    categoria: "Análisis Técnico",
    definicion: "使用Fibonacci比率（23.6%、38.2%、50%、61.8%、78.6%）识别回撤中潜在支撑位/阻力位的工具。61.8%（黄金比率）和50%水平最常用。在SMC中，50%分隔Premium与Discount区域。",
    relacionados: [
      "premium-discount",
      "soporte"
    ]
  },
  {
    id: "rsi",
    termino: "RSI (Relative Strength Index)",
    categoria: "Análisis Técnico",
    definicion: "动量指标，在0到100的范围内衡量价格变动的速度和变化。高于70：超买。低于30：超卖。RSI与价格的背离是可能反转的强烈信号。",
    relacionados: [
      "macd"
    ]
  },
  {
    id: "macd",
    termino: "MACD",
    categoria: "Análisis Técnico",
    definicion: "Moving Average Convergence Divergence。趋势和动量指标。由MACD线（EMA12 - EMA26）、信号线（MACD的EMA9）和柱状图组成。MACD线穿越信号线产生买入/卖出信号。",
    relacionados: [
      "rsi",
      "ema"
    ]
  },
  {
    id: "ema",
    termino: "EMA (Media Móvil Exponencial)",
    categoria: "Análisis Técnico",
    definicion: "对近期数据赋予更大权重的移动平均线，比SMA对价格变化反应更快。加密货币中最常用的EMA：20、50、100和200。价格高于EMA200 = 上升趋势。低于 = 下降趋势。",
    relacionados: [
      "macd",
      "tendencia"
    ]
  },
  {
    id: "stop-loss",
    termino: "Stop Loss",
    categoria: "Gestión de Riesgo",
    definicion: "当价格达到预定义的亏损水平时自动平仓的订单。交易者最重要的工具。在不利走势中保护资金。永远不要在没有止损的情况下交易。",
    ejemplo: "你以45,000买入BTC。设置止损在43,500。如果跌至43,500，仓位自动平仓，将你的损失限制在1,500€或你计算的百分比。",
    relacionados: [
      "take-profit",
      "ratio-rr"
    ]
  },
  {
    id: "take-profit",
    termino: "止盈 (TP)",
    categoria: "Gestión de Riesgo",
    definicion: "当价格达到预设盈利目标时自动平仓的订单。无需持续监控市场即可锁定利润。",
    relacionados: [
      "stop-loss",
      "ratio-rr"
    ]
  },
  {
    id: "ratio-rr",
    termino: "风险回报比 (R:R)",
    categoria: "Gestión de Riesgo",
    definicion: "承担的风险（到止损的距离）与潜在回报（到目标的距离）之间的比率。1:2的风险回报比意味着你赚取的是风险的两倍。建议最低比率：1:2。专业交易者追求1:3或更高。",
    ejemplo: "止损距入场点500欧元，止盈距入场点1,500欧元 → 风险回报比 = 1:3。即使胜率只有40%，你仍然盈利。",
    relacionados: [
      "stop-loss",
      "take-profit"
    ]
  },
  {
    id: "drawdown",
    termino: "回撤",
    categoria: "Gestión de Riesgo",
    definicion: "从资金峰值到下一个谷底的最大跌幅。如果你的账户达到15,000欧元后跌至12,000欧元，回撤为20%。控制最大回撤对长期生存至关重要。",
    relacionados: [
      "gestion-capital"
    ]
  },
  {
    id: "gestion-capital",
    termino: "资金管理",
    categoria: "Gestión de Riesgo",
    definicion: "决定每笔交易承担多少资金风险的规则集合。1-2%规则规定每笔交易风险不超过总资金的1-2%。这是持久交易者与爆仓者之间的区别。",
    relacionados: [
      "drawdown",
      "stop-loss"
    ]
  },
  {
    id: "halving",
    termino: "比特币减半",
    categoria: "Cripto",
    definicion: "比特币代码中预设的事件，每210,000个区块（约4年）发生一次，将矿工每个区块获得的奖励减半。减少BTC的新增供应量。历史上曾在重大牛市之前发生。减半事件发生在2012年、2016年、2020年和2024年。",
    relacionados: []
  },
  {
    id: "altcoin-season",
    termino: "山寨币季节",
    categoria: "Cripto",
    definicion: "山寨币（除比特币外的加密货币）表现大幅超越BTC的时期。通常发生在BTC经历强劲上涨后进入盘整阶段，资金轮动至风险/回报更高的项目。",
    relacionados: [
      "dominancia-btc"
    ]
  },
  {
    id: "dominancia-btc",
    termino: "比特币主导地位",
    categoria: "Cripto",
    definicion: "比特币在加密货币总市值中所占的百分比。高主导地位（>60%）= 资金集中在BTC = 市场保守。低主导地位（<40%）= 资金轮动至山寨币 = 山寨币季节。",
    relacionados: [
      "altcoin-season"
    ]
  },
  {
    id: "defi",
    termino: "DeFi（去中心化金融）",
    categoria: "DeFi",
    definicion: "建立在区块链上的金融应用生态系统，无需中介机构运作。包括去中心化交易所（DEX）、借贷协议、收益耕作、流动性池。智能合约取代银行。",
    relacionados: [
      "amm"
    ]
  },
  {
    id: "amm",
    termino: "AMM (自动做市商)",
    categoria: "DeFi",
    definicion: "使用数学算法（通常为 x*y=k）来定价的去中心化市场协议，而非传统的订单簿。Uniswap、Curve 和 PancakeSwap 是最知名的例子。",
    relacionados: [
      "defi"
    ]
  },
  {
    id: "cpi",
    termino: "CPI（消费者物价指数）",
    categoria: "Macro",
    definicion: "衡量通货膨胀的指标，追踪一篮子商品和服务的价格变化。CPI 高于预期通常会对风险资产（包括加密货币）造成下行压力，因为这预示着美联储可能加息。",
    relacionados: [
      "fed"
    ]
  },
  {
    id: "fed",
    termino: "美联储（Fed）",
    categoria: "Macro",
    definicion: "美国中央银行。其利率决策影响包括加密货币在内的所有全球市场。加息 = 资金成本上升 = 风险资产投资减少 = 加密货币下跌。降息 = 相反效果。",
    relacionados: [
      "cpi"
    ]
  },
  {
    id: "fomo",
    termino: "FOMO（害怕错过）",
    categoria: "Psicología",
    definicion: "害怕错过行情的恐惧。导致交易者在价格大幅上涨后才入场（支付高价且止损设置过紧）。这是加密货币交易中最常见的亏损原因之一。解药：制定清晰的交易计划并严格执行。",
    relacionados: [
      "revenge-trading",
      "overtrading"
    ]
  },
  {
    id: "revenge-trading",
    termino: "Revenge Trading",
    categoria: "Psicología",
    definicion: "在亏损后冲动交易，目的是快速收回损失的资金。这会造成最大的损失，因为决策是基于情绪而非策略。解决方法：在亏损后停止交易并遵循计划。",
    relacionados: [
      "fomo",
      "overtrading"
    ]
  },
  {
    id: "overtrading",
    termino: "Overtrading (过度交易)",
    categoria: "Psicología",
    definicion: "过度交易，进行超出市场合理性的交易次数。通常由无聊、兴奋或绝望驱动。增加手续费，降低交易设置质量，并在心理上造成疲惫。质量重于数量。",
    relacionados: [
      "fomo",
      "revenge-trading"
    ]
  }
];

// GLOSARIO_CATEGORIAS keeps ES tokens as canonical keys — labels are
// resolved at render time via labelCategoria(cat, "zh-CN") from i18n-academy.js.
// Rows below preserve `categoria` in ES for filter-equality + tailwind color map.
export const GLOSARIO_CATEGORIAS = [
  "Smart Money",
  "Análisis Técnico",
  "Gestión de Riesgo",
  "Cripto",
  "DeFi",
  "Macro",
  "Psicología",
];
